// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tuud","content":"styles_content__eOd2R","row":"styles_row__21a81","footer":"styles_footer__3H_CW","phraseLength":"styles_phraseLength__2iUWK"};